import React, { useCallback, useMemo } from "react";
import Logo from "../assets/logo.png";
const VideoPage = ({ data }) => {
  const getComponent = useMemo(() => {
    let src = data?.video || "";
    if (src.includes("youtu")) {
      let videoId = src.split("/");
      videoId = videoId[videoId.length - 1];
      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      console.log(embedUrl);
      return (
        <iframe
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video"
        ></iframe>
      );
    } else {
      return <video src={src} controls className="video" autoPlay loop></video>;
    }
  }, [data?.video]);

  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>

      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="sign_up_form_body">
        <div className="sign_up_form_sub_heading" style={{ marginTop: "10vh" }}>
          Video By
        </div>
        <div className="sign_up_form_heading" style={{ marginTop: "0" }}>
          {data?.first_name || ""} {data?.last_name || ""}
        </div>
      </div>

      <div className="video_container">{getComponent}</div>
    </div>
  );
};

export default VideoPage;
